module.exports = __webpack_public_path__ + "static/media/02_window_collapsed.dfed830a.PNG";